import type { TaskResponse } from '@erp/rpc';
import type { SystemEntity } from '@erp/shared-types';
import { hasSystemEntityLink } from '@/components/system-entities/system-entity-link';
import { readSourceEntity } from './setTaskTypeForm';

type TaskRelatedFields = Pick<
  TaskResponse,
  'anchorEntityType' | 'anchorEntityId' | 'metadata'
>;

/**
 * The record a task is related to: its anchor, else (an untyped task a
 * workflow or a Workbook opened) the source entity its metadata names.
 */
export function taskRelatedEntity(task: TaskRelatedFields): {
  anchorEntityType: TaskResponse['anchorEntityType'];
  anchorEntityId: string | null;
} {
  if (task.anchorEntityType && task.anchorEntityId)
    return {
      anchorEntityType: task.anchorEntityType,
      anchorEntityId: task.anchorEntityId,
    };
  const source = readSourceEntity(task.metadata);
  return {
    anchorEntityType: source?.entityType ?? null,
    anchorEntityId: source?.entityId ?? null,
  };
}

/**
 * The task's related record when it has a detail page to open, else null
 * (the caller falls back to the task page).
 */
export function taskRoutableRecord(
  task: TaskRelatedFields,
): { entityType: SystemEntity; entityId: string } | null {
  const { anchorEntityType, anchorEntityId } = taskRelatedEntity(task);
  if (!anchorEntityType || !anchorEntityId) return null;
  if (!hasSystemEntityLink(anchorEntityType)) return null;
  return { entityType: anchorEntityType, entityId: anchorEntityId };
}
